import React from "react";

const Loaderspinner = () => {
  return (
    <div id="loading-bar-spinner" className="spinner">
      <div className="spinner-icon"></div>
    </div>
  );
};

export default Loaderspinner;
